var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01911 4.05052L8.15771 11.3418L1.01911 18.6331C0.301572 19.366 0.301572 20.5498 1.01911 21.2827C1.73665 22.0156 2.89575 22.0156 3.61329 21.2827L12.0582 12.6572C12.7757 11.9243 12.7757 10.7405 12.0582 10.0076L3.61329 1.38206C2.89575 0.649177 1.73665 0.649177 1.01911 1.38206C0.319971 2.11495 0.301572 3.31763 1.01911 4.05052V4.05052Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9428 18.6143L13.8042 11.323L20.9428 4.03173C21.6603 3.29884 21.6603 2.11495 20.9428 1.38206C20.2253 0.649176 19.0662 0.649176 18.3486 1.38206L9.90373 10.0076C9.18619 10.7405 9.18619 11.9243 9.90373 12.6572L18.3486 21.2827C19.0662 22.0156 20.2253 22.0156 20.9428 21.2827C21.6419 20.5498 21.6603 19.3472 20.9428 18.6143V18.6143Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCloseIcon);
export default __webpack_public_path__ + "static/media/navCloseIcon.a4417c07.svg";
export { ForwardRef as ReactComponent };